export default __webpack_public_path__ + "static/media/BLR25.ad5caa44.jpg";